import React from "react";
import briefr2025 from "@/assets/briefr-2025.gif";

const Index = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <img 
        src={briefr2025} 
        alt="Briefr 2025" 
        className="max-w-md w-full px-4"
      />
    </div>
  );
};

export default Index;
